'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useConnectedWallet } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { logger } from '@/lib/telemetry/logger';
import { useFundingStage } from '../shared/funding-chrome';
import { FundingProviderLoading } from '../shared/funding-provider-loading';
import { FundingConnectedWalletFrame } from './funding-connected-wallet-frame';
import { FundingConnectedWalletStatus } from './funding-connected-wallet-status';
export function FundingConnectedWallet(t0) {
  const $ = _c(54);
  const {
    client,
    active,
    operationId,
    onBack,
    onAddressDeposit,
    onComplete
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  const [showProvider, setShowProvider] = useState(false);
  let t1;
  if ($[0] !== operationId) {
    t1 = operationId === undefined ? {} : {
      operationId
    };
    $[0] = operationId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== active || $[3] !== locale || $[4] !== onComplete || $[5] !== t1) {
    t2 = {
      surface: "web",
      locale,
      active,
      autoStart: true,
      onComplete,
      ...t1
    };
    $[2] = active;
    $[3] = locale;
    $[4] = onComplete;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    state,
    actions
  } = useConnectedWallet(client, t2);
  let t3;
  if ($[7] !== t) {
    t3 = t("connected_wallet_title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useFundingStage(t3, false, onBack);
  let t4;
  let t5;
  if ($[9] !== state.error) {
    t4 = () => {
      if (state.error) {
        logger.warn("onramp.connected_wallet_failed", {
          code: state.error
        });
      }
    };
    t5 = [state.error];
    $[9] = state.error;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== actions) {
    t6 = () => {
      actions.submitted();
    };
    $[12] = actions;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const success = t6;
  let t7;
  if ($[14] !== actions) {
    t7 = () => actions.providerError();
    $[14] = actions;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const providerError = t7;
  if (!state.operation) {
    if (state.error) {
      let t8;
      if ($[16] !== t) {
        t8 = t("connected_wallet_unavailable");
        $[16] = t;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      let t9;
      if ($[18] !== t8) {
        t9 = <p className="text-body text-foreground-secondary">{t8}</p>;
        $[18] = t8;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      const t10 = state.busy;
      let t11;
      if ($[20] !== actions) {
        t11 = () => void actions.retry();
        $[20] = actions;
        $[21] = t11;
      } else {
        t11 = $[21];
      }
      let t12;
      if ($[22] !== t) {
        t12 = t("retry");
        $[22] = t;
        $[23] = t12;
      } else {
        t12 = $[23];
      }
      let t13;
      if ($[24] !== state.busy || $[25] !== t11 || $[26] !== t12) {
        t13 = <AnimatedButton variant="secondary" disabled={t10} onClick={t11}>{t12}</AnimatedButton>;
        $[24] = state.busy;
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
      } else {
        t13 = $[27];
      }
      let t14;
      if ($[28] !== t) {
        t14 = t("connected_wallet_address_fallback");
        $[28] = t;
        $[29] = t14;
      } else {
        t14 = $[29];
      }
      let t15;
      if ($[30] !== onAddressDeposit || $[31] !== t14) {
        t15 = <AnimatedButton variant="secondary" onClick={onAddressDeposit}>{t14}</AnimatedButton>;
        $[30] = onAddressDeposit;
        $[31] = t14;
        $[32] = t15;
      } else {
        t15 = $[32];
      }
      let t16;
      if ($[33] !== t13 || $[34] !== t15 || $[35] !== t9) {
        t16 = <div role="alert" className="flex flex-col gap-3">{t9}{t13}{t15}</div>;
        $[33] = t13;
        $[34] = t15;
        $[35] = t9;
        $[36] = t16;
      } else {
        t16 = $[36];
      }
      return t16;
    }
    let t8;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <FundingProviderLoading />;
      $[37] = t8;
    } else {
      t8 = $[37];
    }
    return t8;
  }
  if (!state.operation.widget || state.operation.state !== "wallet_widget" && !showProvider) {
    let t8;
    if ($[38] !== state.operation.state || $[39] !== state.operation.widget) {
      t8 = state.operation.state === "below_minimum" && state.operation.widget ? {
        onTopUp: () => setShowProvider(true)
      } : {};
      $[38] = state.operation.state;
      $[39] = state.operation.widget;
      $[40] = t8;
    } else {
      t8 = $[40];
    }
    let t9;
    if ($[41] !== state.operation || $[42] !== t8) {
      t9 = <FundingConnectedWalletStatus operation={state.operation} {...t8} />;
      $[41] = state.operation;
      $[42] = t8;
      $[43] = t9;
    } else {
      t9 = $[43];
    }
    return t9;
  }
  let t8;
  if ($[44] !== providerError || $[45] !== state.operation.widget || $[46] !== success) {
    t8 = <FundingConnectedWalletFrame widget={state.operation.widget} onReady={_temp} onSuccess={success} onError={providerError} />;
    $[44] = providerError;
    $[45] = state.operation.widget;
    $[46] = success;
    $[47] = t8;
  } else {
    t8 = $[47];
  }
  let t9;
  if ($[48] !== state.error || $[49] !== t) {
    t9 = state.error === "provider_error" ? <p role="alert" className="p-3 text-caption text-foreground-secondary">{t("connected_wallet_provider_error")}</p> : null;
    $[48] = state.error;
    $[49] = t;
    $[50] = t9;
  } else {
    t9 = $[50];
  }
  let t10;
  if ($[51] !== t8 || $[52] !== t9) {
    t10 = <div className="overflow-hidden rounded-control bg-background-primary">{t8}{t9}</div>;
    $[51] = t8;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  return t10;
}
function _temp() {}